// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__gDRm5","inner":"Table_inner__y7lVs","table-action":"Table_table-action__rnmFL"};